// @ts-nocheck
/* eslint-disable */
import { M3D_TEXTURE } from '~/scene/provider/3d/texture-mapping';
import Dialog from "~/ui/dialog";
import { addListener, removeListener, makeEvent } from "~/lib/signals";
import { CONFIG, Scene, setGlobals, store } from "./globals";
import IconAction from "~/ui/icon-action";
import { altitudeProfile } from "~/util/providers/altitude";
import { showMarkerLabel } from "~/util/markerTitle";
import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";
import InteractivePoint from "./interactive-point";
import Item from "./item";
import { getContextMenu } from "./context-menu"
import MyMapsShare from "~/es6/mymaps.share";
import { MAX_URL_LENGTH } from "~/util/constants";
import InteractiveLineChart from '~/interactivelinechart';
import { NOTIFICATIONS_TYPE } from "~/util/notifications";
import MyMapsMapyBoxItem from "~/ui/dialogs/mymaps-mapybox-item";
import { getCreateLikeData, mapyboxAnalyticsSave } from "~/util/mapybox";
import { getFolderData } from "~/util/providers/mapybox";
import { createMyMapsSharing } from "~/ui/mymaps/sharing";
import { createUserNote } from "~/ui/user-note/note";
import { setCoordinates } from "~/state/map/state";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";
import { isNoteHeightSafe } from "~/util/distance-meter-user-marks";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import MyMapsBox from "~/ui/mymaps/box";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import createSDSIcon from "~/ui/icon";
import { MYMAPS_CLOSE, MYMAPS_SHARE } from "~/ui/sds-compatible-icons";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "~/ui/tooltip";
import { createContextMenuBtn } from "~/ui/mymaps/context-menu-btn";
import { IMapyBoxItem } from "~/interfaces";
import MyMapsMoveItems from "~/ui/dialogs/mymaps-move-items";
import MyMapsRemove from "~/ui/dialogs/mymaps-remove";
import SceneCoords from "~/scene/common/coords";
import WasmBulkMode from "~/wasm/store/bulk-mode";

export const TYPES = {
	EMPTY: -1,
	START: 0,
	MIDDLE: 1,
	END: 2
};
const LINE_CHART_PADDING = 2 * 16;
// cisla jsou posuny px
const CURSOR_DEF = "url(/img/distancemeter/default.png) 3 2, crosshair";
const CURSOR_ADD = "url(/img/distancemeter/add.png) 3 3, crosshair";
const DISTANCEMETER_ACTION_TRESHOLD = 0;
const ITEM_HEIGHT = 43;
const STYLE_ID = "sortableTableStyles";
const M3D_VALUES = {
	MIN_KM: 50, // od kolika [km] zacit drobit trasu na POINTS_LENGTH
	MAX_MIN_DISTANCE: 1000, // od kolika metru prevyseni (max-min) zacit drobit trasu
	POINTS_LENGTH: 25000 // na kolik bodu nadrobit trasu?
};

type TMymapsMode = "create" | "edit" | "replace";

export function initModule(global: {
	store: IStore;
	CONFIG: IConfig;
	Scene: any;
}) {
	setGlobals(global);
}

/**
 * Hlavni trida mereni vzdalenosti.
 * - geom - trida pro dedeni geometrii
 * - point - bod geometrie
 * - line - cara geometrie
 * - item - jedna polozka
 * - interactive-point - trida pro obsluhu interaktivity (zadavani noveho bodu)
 */
export default class DistanceMeter {
	_storeUnsubscribe: Unsubscribe;

	_ctxtMenuBtn: ReturnType<typeof createContextMenuBtn>;

	_mymapsBox: ReturnType<typeof MyMapsBox>;

	constructor (owner, Notifications) {
		this._owner = owner;
		this._notifications = Notifications;
		this._hasError = false;
		this._dom = {
			container: node("div", { className: "dm-container" })
		};
		this._active = false;
		this._readOnly = false;
		this._readOnlyCoords = [];
		this._readOnlyDistance = 0;
		this._dmid = null;
		this._items = [];
		this._altitudeFrpc = null;
		this._lineChart = null;
		this._altitudeData = null;
		this._interactive = null;
		this._prevOffsetWidth = 0;
		this._cursor = null;
		this._storeUnsubscribe = null;
		this._layers = {
			points: Scene.createLayerMarker("distancemeter-point"),
			lines: Scene.createLayerGeometry("distancemeter-geom"),
			label: Scene.createLayerMarker("distancemeter-label"),
			distanceMeter: null,
			free: null,
		};
		this._contextMenuItems = [];
		this._allowHover = true;
		this._interactivePoint = new InteractivePoint(this);
		this._headerHeight = 0;
		this._likeData = null;
		this._likeChange = false;
		this._fromLike = false;
		this._m3dData = {
			active: false,
			hover: false,
			dad: false
		};
		this._dragging = false;
		this._userNote = null;
		this._mymapsBox = null;
		this._noteSafeHeight = true;
		this._ctxtMenuBtn = null;

		this._actions = {
			save: new IconAction({
				icon: "star-line",
				title: _("action.save.title"),
				callback: (e) => {
					const isReplace = this._likeData && "parent_name" in this._likeData;

					this._mymapsDialog(isReplace ? "replace" : "create");
				}
			}),
			share: new IconAction({
				icon: "",
				sdsIcon: MYMAPS_SHARE,
				title: _("action.share.title"),
				callback: function(e) {
					if (window.location.toString().length < MAX_URL_LENGTH) {
						let dataAction = this._buildActionData();
						let data = this._likeData && !this._likeChange ? Object.assign({}, this._likeData, { like: !("owner_name" in this._likeData), showLabel: this._likeData ? true : false }) : {
							title: dataAction.title,
							type: "measure"
						};
						let first = this._items[0].getCoords().toWGS84(0);
						let last = this._items[this._items.length - 1].getCoords().toWGS84(0);
						data["measureLogData"] = {
							count: this._items.length - 1,
							fromLat: first[1],
							fromLon: first[0],
							toLat: last[1],
							toLon: last[0],
							length: this.distance,
							end_measure: "share"
						};

						var sharePopup = new MyMapsShare(data, cbData => {
							if (cbData.name == "popup-close") {
								if (this._likeData && !this._likeChange && this._likeData.public != cbData.public) {
									this._likeData.public = cbData.public;
									Mapy.getComponent("places").listRefreshData();
								}
							}
							sharePopup.destroy();
							sharePopup = null;
						});
						sharePopup.open();
					} else {
						this._notifications.notify({
							type: NOTIFICATIONS_TYPE.ERROR,
							content: _("distanceMeter.URLTooLong"),
							autohide: true,
							duration: 5000
						});
					}
				}.bind(this)
			}),
			download: new IconAction({
				icon: "export2",
				title: _("action.download.title"),
				callback: function(e) {
					const exportData = this._items.length ? this._getExportData() : {};

					if (this._likeData?.usertitle) {
						exportData.title = this._likeData.usertitle;
					} else {
						const distance = Mapy.Util.formatDistancemeterDistance(this.distance).string;

						exportData.title = _("distanceMeter.module.title", {distance});
					}

					new MyMapsExport({
						data: {
							name: "distancemeter",
							data: exportData,
						},
						onExport: () => {
							const first = this._items[0].getCoords().toWGS84(0);
							const last = this._items[this._items.length - 1].getCoords().toWGS84(0);

							Mapy.getComponent("logger").log("measure", {
								end_measure: "download",
								count: this._items.length - 1,
								fromLat: first[1],
								fromLon: first[0],
								toLat: last[1],
								toLon: last[0],
								length: this.distance
							});
						},
					}).open();
				}.bind(this)
			}),
			clear: new IconAction({
				icon: "reload",
				title: _("distanceMeter.reload"),
				callback: function(e) {
					let first = this._items[0].getCoords().toWGS84(0);
					let last = this._items[this._items.length - 1].getCoords().toWGS84(0);
					Mapy.getComponent("logger").log("measure", {
						end_measure: "clear",
						count: this._items.length - 1,
						fromLat: first[1],
						fromLon: first[0],
						toLat: last[1],
						toLon: last[0],
						length: this.distance
					});
					this.removeAll();
					this._resize();
					Mapy.getComponent("history").save();
					makeEvent("distancemeter-clear", this);
				}.bind(this)
			})
		};

		this._sortableIndex = 0;
		this._sortableSheet = document.querySelector(`style#${STYLE_ID}`);
		this._isSortabling = false;

		this._userTitle = null;

		this._build();
		this.redraw();
		this._makeContextMenu();
		this._interactivePoint.cb = state => {
			this._showContinue(state);
		};

		addListener(this, "dim-is-not-share", data => {
			if (this._likeData && data.data.dim == this._likeData.id) {
				this._clearLikeData();
				this.setState(this.getState());
				Mapy.getComponent("history").save();
			}
		}, Mapy.getComponent("dimcurator"));

		// priprava pro tisk
		addListener(this, "print-page", () => {
			if (this._active) {
				this._interactivePoint.hide(true);
			}

			const printMode = Mapy.getComponent("print").mode;

			// 4 = stahnout jako obrazek, 0 tisk
			if (this._lineChart && printMode !== 4) {
				this._lineChart.setData(undefined, undefined, {
					width: 700
				});
			}

			this._userNote?.print();
			this._mymapsBox?.print();
		});

		addListener(this, "print-done", () => {
			if (this._lineChart) {
				this._prevOffsetWidth = 0;
				this._resize();
			}
		});

		Scene.addListener("provider-change", data => {
			if (data.data.newProvider == "m3d" && this._active) {
				this._interactivePoint.hide(true);
				this._enableM3d(true);
			}
		});

		// vykresleni pro 3d
		Scene.addListener("provider-changed", event => {
			if (!this._active) return;

			let data = event.data;

			if (data.name == "m3d") {
				this._createLayers3d();
			}
			else {
				this._removeLayers3d();
				this._disableM3d();
			}
		}, this);

		this._resizeHandler = e => {
			this._resize(e.data);
		};
		this._resizeSignal = null;
	}

	get dragging() {
		return this._dragging;
	}

	set dragging(dragging: boolean = false) {
		this._dragging = dragging;
	}

	/**
	 * Vrstva pro geometrie.
	 *
	 * @return {SceneLayerGeometry}
	 */
	get layers () {
		return this._layers;
	}

	/**
	 * Povolit/zakazat hover - tabulka, geometrie.
	 */
	set allowHover (state) {
		this._allowHover = state;
	}

	/**
	 * Ziskat instaci se tridou pro interaktivni bod.
	 *
	 * @return {InteractivePoint}
	 */
	get interactivePoint () {
		return this._interactivePoint;
	}

	/**
	 * Vzdalenost mereni v metrech
	 *
	 * @return {Number}
	 */
	get distance () {
		if (this._readOnly && !this._m3dData.active) {
			return this._readOnlyDistance;
		}

		let coords = this._items.map(i => i.getCoords());
		let sum = 0;

		coords.forEach((item, ind) => {
			if (ind > 0) {
				sum += coords[ind].distance(coords[ind - 1]);
			}
		});

		return sum;
	}

	/**
	 * Plocha mereni v m2/km2.
	 *
	 * @return {Number}
	 */
	get area () {
		let area = 0;
		let coords = this._items.map(i => i.getCoords());

		if (coords.length > 2) {
			let merc = coords.map(item => {
				return item.toMercator();
			});

			area = Mapy.Util.polygonArea(merc, true);
		}

		return Math.floor(area);
	}

	/**
	 * Je to read only mereni?
	 *
	 * @return {Boolean}
	 */
	get readOnly () {
		return this._readOnly;
	}

	/**
	 * Vrátí uživatelský titulek
	 * @return {string}
	 */
	get userTitle () {
		return this._userTitle;
	}

	/**
	 * Aktivace.
	 */
	activate () {
		if (this._active)
			return this;

		if (!this._cursor && !CONFIG.inFrame && !CONFIG.wasmEnabled) {
			this._cursor = Mapy.Cursor.add({ cursor: CURSOR_DEF, callback: this });
		}

		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));

		// prvni cary, pak az body
		Scene.addLayer(this._layers.lines).enable();
		Scene.addLayer(this._layers.points).enable();

		this._interactivePoint.activate();
		this._active = true;

		this._resizeSignal = addListener(this, "resize", this._resizeHandler);

		this._disableM3d();
		this._enableM3d();

		let scroll = Mapy.getComponent("layout").getScrollNode();
		scroll && scroll.addEventListener("scroll", this, false);

		this.show();
		this._resize();

		let first = null;
		let last = null;
		let assignObj = {};
		if (this._items.length) {
			first = this._items[0].getCoords().toWGS84(0);
			last = this._items[this._items.length - 1].getCoords().toWGS84(0);
			assignObj = {
				fromLat: first[1],
				fromLon: first[0],
				toLat: last[1],
				toLon: last[0],
				count: this._items.length - 1,
				length: this.distance
			};
		}
		Mapy.getComponent("logger").log("measure", Object.assign({ end_measure: "activate" }, assignObj));

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		return this;
	}

	/**
	 * Deaktivace.
	 */
	deactivate () {
		if (!this._active)
			return this;

		if (this._cursor) {
			Mapy.Cursor.remove(this._cursor);
			this._cursor = null;
		}

		this._onCloseAction && this._onCloseAction();

		this._layers.lines.disable();
		this._layers.points.disable();
		this._removeLayers3d();

		Scene.removeLayer(this._layers.lines);
		Scene.removeLayer(this._layers.points);
		this._storeUnsubscribe?.();
		this._storeUnsubscribe = null;

		this._interactivePoint.deactivate();
		this._active = false;

		removeListener(this._resizeSignal);
		this._resizeSignal = null;

		let scroll = Mapy.getComponent("layout").getScrollNode();
		scroll && scroll.removeEventListener("scroll", this, false);

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		let first = null;
		let last = null;
		let assignObj = {};
		if (this._items.length) {
			first = this._items[0].getCoords().toWGS84(0);
			last = this._items[this._items.length - 1].getCoords().toWGS84(0);
			assignObj = {
				fromLat: first[1],
				fromLon: first[0],
				toLat: last[1],
				toLon: last[0],
				count: this._items.length - 1,
				length: this.distance
			};
		}
		Mapy.getComponent("logger").log("measure", Object.assign({ end_measure: "deactivate" }, assignObj));

		return this;
	}

	/**
	 * Zobrazeni kontentu.
	 */
	show () {
		if (this._hasError) {
			this._deleteError();
		}
		this._dom.container.classList.remove("hide");

		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}
		else {
			Mapy.CML.state = {
				route: {
					showGeometries: true
				}
			};

			Scene.removeLayer(this._layers.lines);
			Scene.removeLayer(this._layers.points);
			Scene.addLayer(this._layers.lines);
			Scene.addLayer(this._layers.points);

		}

		const wasmBulk = new WasmBulkMode();

		for (const item of this._items) {
			item.setWasmVisibility(true, wasmBulk);
		}

		wasmBulk.run();

		this._mapRedraw();
	}

	/**
	 * Skryti kontentu.
	 */
	hide () {
		this._dom.container.classList.add("hide");

		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}

		if (Mapy.active[0] != Mapy.getComponent("search")) {
			Mapy.CML.state = {
				route: {
					showGeometries: false
				}
			};
		}

		const wasmBulk = new WasmBulkMode();

		for (const item of this._items) {
			item.setWasmVisibility(false, wasmBulk);
		}

		wasmBulk.run();
	}

	/**
	 * Kontainer s celym merenim.
	 *
	 * @return {Element}
	 */
	getContainer () {
		return this._dom.container;
	}

	/**
	 * Ziskani polozek mereni.
	 *
	 * @return {Array}
	 */
	getItems () {
		return this._items;
	}

	/**
	 * Ziskani jedne polozky - souradnic.
	 *
	 * @return {SceneCoords}
	 */
	getOneItem () {
		return (this._items.length ? this._items[0].getCoords() : null);
	}

	/**
	 * Odstraneni vseho, zrusime readonly stav.
	 */
	removeAll () {
		this._readOnly = false;
		this._readOnlyCoords = [];
		this._readOnlyDistance = 0;
		this._abortAltitudeRequest();
		this._interactivePoint.hide(true);
		this._dom.title.textContent = _("distanceMeter.title");
		this._removeLayers3d();

		const wasmBulk = new WasmBulkMode();

		while (this._items.length) {
			let item = this._items.pop();
			item.destroy(wasmBulk);
		}

		wasmBulk.run();

		this._updateHeader();
		this._showContinue();

		if (!this._fromLike) {
			this._clearLikeData();
		}

		this._noteSafeHeight = true;
		this.redraw();
	}

	/**
	 * Nastaveni stavu.
	 *
	 * @param {Object} data Data k nastaveni
	 * @param {String} [data.title = ""] Volitelny titulek
	 * @param {Boolean} [fromHistory] Obnoveni z historie
	 */
	setState (data, fromHistory) {
		if ((fromHistory && !data.x && !data.y && !data.z) || CONFIG.inFrame) {
			data.view = true;
		}

		this._onCloseAction = data.onClose || null;

		this._change(false);

		let showLabel = data.showLabel || 0;

		if (data.likeData) {
			this._likeData = data.likeData;
			this._fromLike = true;

			data = {
				view: true,
				readonly: !!this._likeData.data.readonly,
				rm: this._likeData.data.points,
				title: this._likeData.usertitle || this._likeData.title
			}

			Mapy.CML.state = {
				route: {
					showGeometries: false
				}
			};
			this._ctxtMenuBtn.show();
		}

		if (data.interactive) {
			this._interactivePoint.show();
		}

		if (!data.rm && !data.dmid) {
			this._createLayers3d();
			return;
		}

		this.removeAll();
		this._readOnly = true;
		this._dom.info.classList.remove("error");
		this._dom.title.textContent = data.title || _("distanceMeter.title");

		this._userTitle = data.title || null;
		this._dom.likeText.innerHTML = "";
		this._dom.likeText.classList.remove("foreign");
		this._dom.likeText.classList.remove("empty");
		this._userNote?.destroy();
		this._mymapsBox?.destroy();
		this._mymapsBox = null;
		this._userNote = null;

		if (this._likeData) {
			if (this._likeData.foreign) {
				this._dom.likeText.classList.add("foreign");

				this._dom.likeText.append(createMyMapsSharing({
					data: this._likeData,
				}));

				if (this._likeData.description) {
					this._userNote = createUserNote({
						data: this._likeData,
						foreign: true,
						onNoteOpen: container => {
							this._onNoteOpen(container);
						},
					});

					this._dom.likeText.append(this._userNote.container);
				}
			} else {
				this._mymapsBox = new MyMapsBox({
					isPremiumUser: isPremiumNoteUser(),
					noteVersion: getNoteVersion(),
					data: this._likeData,
					folder: {
						id: this._likeData.parent_id,
						title: this._likeData.parent_name,
					},
					onSignal: signal => {
						switch (signal.name) {
							case "like-update":
								if (this._active) {
									Object.assign(this._likeData, signal.updateData);
									this._dom.title.textContent = this._likeData.usertitle || this._likeData.title;
								}
								break;

							case "note-open":
								this._onNoteOpen(signal.container);
								break;

							case "delete":
								this._clearLikeData();
								Mapy.getComponent("history").save(true);
								break;

							case "like-move":
								this._likeData.parent_id = signal.folderId;
								this._likeData.parent_name = signal.folderTitle;
								break;

							default:
						}
					},
				});

				this._dom.likeText.append(this._mymapsBox.container);
			}

			this._dom.container.classList.add("like");
		}
		else {
			this._dom.container.classList.remove("like");
		}


		let coords;

		// mame dmid a tedy nacteme vec z oblibenych jako readonly bez ohledu na to, jestli je nebo neni readonly nastaveno
		if (data.dmid) {
			this._dmid = data.dmid;

			if (data.rm) {
				coords = Scene.stringToCoords(data.rm);

				this._addCoords(coords);

				if (data.view) {
					const centerZoom = Scene.computeCenterZoom(coords, true);
					const [longitude, latitude] = centerZoom[0].toWGS84();

					store.dispatch(setCoordinates({
						longitude,
						latitude,
						zoom: centerZoom[1],
						animate: true,
					}));
				}
			} else {
				Mapy.ProviderMapyBox.likeDetail(data.dmid).then(data => {
					coords = Scene.stringToCoords(data.like.data.points);
					this._hasError = false;

					this._addCoords(coords);

					if (data.view) {
						let centerZoom = Scene.computeCenterZoom(coords, true);
						const [longitude, latitude] = centerZoom[0].toWGS84();

						store.dispatch(setCoordinates({
							longitude,
							latitude,
							zoom: centerZoom[1],
							animate: true,
						}));
					}
				}, () => {
					this._dom.info.classList.add("error");
					this._dom.info.textContent = _("distanceMeter.errForbidden");
					this._hasError = true;
				});
			}
		}
		// mame souradnice ve forme retezce
		else {
			coords = Scene.stringToCoords(data.rm || "");

			this._readOnly = !!data.readonly;
			this._addCoords(coords);
		}

		if ((data.view && !data.dmid) || ("p" in data && data.p == "3")) {
			const centerZoom = Scene.computeCenterZoom(coords, true);

			if (coords.length == 1) {
				const [longitude, latitude] = coords[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: data.z ? parseInt(data.z) : centerZoom[1],
					animate: false,
				}));
			} else {
				const [longitude, latitude] = centerZoom[0].toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: centerZoom[1],
					animate: !fromHistory && !CONFIG.inFrame,
				}));
			}
		}

		this._showContinue();

		// vpacime na spravne misto info o mereni
		if ("p" in data && data.p == "3") {
			let area = this.area;
			let areaData = Mapy.Util.formatArea(area);
			let overlay = node("div", {
				className: "bottom-overlay",
				innerHTML: _("distanceMeter.overlay", {
					length: Mapy.Util.formatDistancemeterDistance(this.distance).string,
					area: areaData.show ? areaData.value : 0,
					unit: areaData.unit
				})
			});
		}

		this._enableM3d();
		this._resize();

		if (this._likeData && showMarkerLabel(showLabel, this._likeData.usertitle, this._likeData.title)) {
			this._showLabelInFrame(showLabel);
		}

		this._fromLike = false;
	}

	/**
	 * Ziskani stavu.
	 *
	 * @return {Object}
	 */
	getState () {
		if (this._likeData && !this._likeChange) {
			return {};
		}

		let coords = [];
		let data = {};

		if (this._readOnly && !this._m3dData.active) {
			if (this._items.length) {
				if (this._dmid) {
					data.dmid = this._dmid;
				}

				data.readonly = 1;
			}
		} else {
			this._items.forEach(item => {
				coords.push(item.getCoords());
			});

			data.rm = Scene.coordsToString(coords);
		}

		return data;
	}

	wasmClick(coords, clientX: number, clientY: number) {
		this._mapClick(coords, clientX, clientY);
	}

	/**
	 * Pridani souradnic na pozici.
	 */
	add(coordsInput, index) {
		const coords = coordsInput instanceof SceneCoords ? coordsInput : Scene.coordsFromWGS84(coordsInput[0], coordsInput[1]);
		let newItem = null;
		let len = this._items.length;

		if (typeof index === "number" && index >= 0 && index < len) {
			this._items[index].endCoords = coords;
			newItem = new Item(this, Scene, coords, this._items[index + 1].getCoords());
			this._items.splice(index + 1, 0, newItem);
		} else {
			newItem = new Item(this, Scene, coords, null);
			this._items.push(newItem);
		}

		this.logPoint(newItem, coords.toWGS84(0));

		this.redraw({
			add: true
		});

		if (this._items.length == 1) {
			this._resize();
		}

		this.setSEO();
		Mapy.getComponent("history").save();

		return newItem;
	}

	/**
	 * Odstraneni polozky na indexu.
	 *
	 * @param {Number} index
	 */
	remove (index) {
		let firstPoint = this._items[0].getCoords().toWGS84(0);
		let lastPoint = this._items[this._items.length - 1].getCoords().toWGS84(0);
		let removedCoords = this._items[index].getCoords().toWGS84(0);
		let len = this._items.length - 1;
		let last = index == len;

		if (index >= 0 && index <= len) {
			let item = this._items.splice(index, 1);
			item[0].destroy();
		}

		if (last && CONFIG.wasmEnabled) {
			this._items[len - 1].endCoords = null;
		}

		this.redraw({
			remove: {
				last
			}
		});

		if (last || CONFIG.wasmEnabled) {
			this.sectionHighlight(false, 0, true);
		}

		this._showContinue();

		Mapy.getComponent("logger").log("measure", {
			end_measure: "point-removed",
			count: this._items.length - 1,
			fromLat: firstPoint[1],
			fromLon: firstPoint[0],
			toLat: lastPoint[1],
			toLon: lastPoint[0],
			pointLat: removedCoords[1],
			pointLon: removedCoords[0],
			length: this.distance
		});

		if (this._items.length == 0) {
			this._resize();
		}

		this.setSEO();
		Mapy.getComponent("history").save();
	}

	/**
	 * Nastaveni kurzoru - pridavani bodu.
	 */
	setAddCursor () {
		this._setCursor(CURSOR_ADD);
	}

	/**
	 * Nastaveni kurzoru - def.
	 */
	setDefCursor () {
		this._setCursor(CURSOR_DEF);
	}

	/**
	 * Nastaveni SEO.
	 */
	setSEO () {
		if (this.distance > 0) {
			let areaSeo = "";
			let area = this.area;
			let areaData = Mapy.Util.formatArea(area);

			if (areaData.show) {
				areaSeo = ", " + _("distanceMeter.area").toLowerCase() + " " + areaData.value + " " + areaData.unit + "2";
			}

			Mapy.SEO.set(_("distanceMeter.seo") + " - " + Mapy.Util.formatDistancemeterDistance(this.distance).string + areaSeo);
		} else {
			Mapy.SEO.set(_("distanceMeter.seo"));
		}
	}

	getBottomPanelText () {
		let distance = this.distance;

		return (this._items.length && distance > 0 ? _("distanceMeter.seo") + ": " + Mapy.Util.formatDistancemeterDistance(this.distance).string : null);
	}

	/**
	 * Hlavni funkce - update dat, prekresleni, vytvoreni tabulky.
	 * Pruchod vsemy itemy - nastavi se predchozi/dalsi bod, geometrie se pokazde znovu nevykresluji, pouze pri zmene!
	 * Update modulu, tabulka se vzdycky znovu prekresluje.
	 *
	 * @param {Object} [opts]
	 * @param {Boolean} [opts.add] Prekresleni pri aktualizaci tabulky - pridvavani bodu
	 * @param {Boolean} [opts.noFull] Prekresleni pouze castecne, aktualizace hodnot a tabulky
	 * @param {Boolean} [opts.remove = { last: false/true }] Byl smazan prvek, byl posledni?
	 */
	redraw (opts = {}) {
		// spolecne
		let distance = Mapy.Util.formatDistancemeterDistance(this.distance);
		let area = Mapy.Util.formatArea(this.area);

		// area a distance update
		this._dom.distanceValue.textContent = distance.distance;
		this._dom.distanceUnit.textContent = distance.unit;
		this._dom.areaValue.textContent = area.value;
		this._dom.areaUnit.textContent = area.unit;

		// update tabulky
		this._buildTable(opts);

		this._setHeights();

		if (!opts.noFull) {
			if (!this._fromLike) {
				this._change(true);
			}

			// pocet polozek
			if (!this._items.length) {
				this._dom.info.textContent = _("distanceMeter.start");
				this._dom.container.classList.add("empty");
			}
			else if (this._items.length == 1) {
				this._dom.container.classList.remove("empty");
				this._dom.container.classList.add("one-item");
			}
			else {
				this._dom.info.textContent = "";
				this._dom.container.classList.remove("empty");
				this._dom.container.classList.remove("one-item");
			}

			// update markeru
			let lastInd = this._items.length - 1;


			this._items.forEach((item, ind) => {
				let type;

				if (ind == 0) {
					type = TYPES.START;
				} else if (ind == lastInd) {
					type = TYPES.END;
				} else {
					type = TYPES.MIDDLE;
				}

				// nastavime
				item.index = ind;
				item.type = type;
				item.endCoords = ind != lastInd ? this._items[ind + 1].getCoords() : null;
				item.prev = ind > 0 ? this._items[ind - 1] : null;
				item.next = ind != lastInd ? this._items[ind + 1] : null;
			});

			this._updateHeader();

			// scroll na posledni radek
			let removeLast = opts.remove && opts.remove.last;

			if ((!opts.remove && this._items.length) || (removeLast && this._dom.scrollSection.scrollTop != 0)) {
				this._dom.scrollSection.scrollTop = Math.max(this._dom.tableData.offsetHeight - 5, 0);
			}

			// update spodni listy na mobilu
			if (Mapy.Util.isMobile()) {
				Mapy.getComponent("distanceMeter").setBottomPanel();
			}

			this._interactivePoint.cleanCache();

			// vyskovy profil
			if (this._items.length) {
				this._getAltitude();
			} else {
				if (this._lineChart) {
					this._lineChart.destroy();
					this._lineChart = null;
					this._altitudeData = null;
				}

				this._dom.lineChartCont.innerHTML = "";
			}
		}
	}

	updateWasmPoint(index: number, coords: SceneCoords) {
		// specialni pripad
		if (index === 0) {
			this._items[0].startCoords = coords;
		} else {
			const curLineInd = index - 1;
			const nextLineInd = curLineInd + 1;

			this._items[curLineInd].endCoords = coords;

			if (this._items[nextLineInd]) {
				this._items[nextLineInd].startCoords = coords;
			}
		}

		this.redraw({
			noFull: true,
		});
	}

	logPoint (newPoint, coords) {
		let firstPoint = this._items[0].getCoords().toWGS84(0);
		let lastPoint = this._items[this._items.length - 1].getCoords().toWGS84(0);
		Mapy.getComponent("logger").log("measure", {
			end_measure: newPoint ? "point-added" : "point-moved",
			count: this._items.length - 1,
			fromLat: firstPoint[1],
			fromLon: firstPoint[0],
			toLat: lastPoint[1],
			toLon: lastPoint[0],
			pointLat: coords[1],
			pointLon: coords[0],
			length: this.distance
		});
	}

	handleEvent (e) {
		switch (e.type) {
			case "click":
				if (this._dom.exitBtn.contains(e.target)) {
					if (this._items.length && !(this._likeData && !this._likeChange)) {
						let dialog = new Dialog({
							title: _("distanceMeter.closeTitle2"),
							desc: _("gpx.content.closeDesc")
						});
						dialog.setBasic({
							closeTxt: "close2",
							bindEnter: true,
							cb: () => {
								this._exit();
							}
						});
						dialog.open();
					}
					else {
						this._exit();
					}
				}
				break;

			case "scroll":
				this._updateHeader();
				break;

			case "sortable-start":
				this._isSortabling = true;
				break;
			case "sortable-move":
				let prevSibling = document.querySelector(".prevSibling");
				if (prevSibling) {
					prevSibling.classList.remove("prevSibling");
				}
				if ("placeholder" in e.detail && e.detail.placeholder) {
					let placeholder = e.detail.placeholder;
					if (placeholder.previousSibling) {
						placeholder.previousSibling.classList.add("prevSibling");
						this._dom.tableHeader.classList.add("hover");
					} else {
						this._dom.tableHeader.classList.remove("hover");
					}
				}
				break;
			case "sortable-end":
				let prevState = this._getGeometryCoordsData();
				let temp = Array.from(this._items);
				let first = temp.shift();
				let coords = [first.getCoords()];
				let order = Array.from(e.detail.order);
				let dontHistorySave = false;
				this._fromLike = true;
				this.removeAll();
				this._fromLike = false;

				for (let index = 0; index < temp.length; index++) {
					coords.push(temp[order[index]].getCoords());
				};

				if (this._likeData) {
					this._likeData.data.points = Scene.coordsToString(coords);
					this.setState({ likeData: this._likeData });
					if (prevState != this._likeData.data.points) {
						this._change(true);
					}
					else {
						dontHistorySave = true;
					}
				}
				else {
					this.setState({ rm: Scene.coordsToString(coords) });
				}

				this._isSortabling = false;
				let firstPoint = this._items[0].getCoords().toWGS84(0);
				let lastPoint = this._items[this._items.length - 1].getCoords().toWGS84(0);
				Mapy.getComponent("logger").log("measure", {
					end_measure: "sortable-end",
					count: this._items.length - 1,
					fromLat: firstPoint[1],
					fromLon: firstPoint[0],
					toLat: lastPoint[1],
					toLon: lastPoint[0],
					length: this.distance
				});

				if (!dontHistorySave) {
					Mapy.getComponent("history").save();
				}
				break;

			case "photo-detail-close":
			case "photo-gallery-close":
				this._active && !Mapy.getComponent("gallery").isActive() && this.setSEO();
				break;
		}
	}

	_mapClick(coords, clientX, clientY) {
		if (this._readOnly || this._m3dData.active || !Scene) {
			return;
		}

		if (this._items.length) {
			let lastCoords = this._items[this._items.length - 1].getCoords();
			let distance = lastCoords.distance(coords);

			// 2x klik, druhy bod ma 0 vzdalenost od posledniho, takze jej preskocime
			if (distance <= 1) {
				return;
			}
		}

		if (Mapy.Util.isMobile()) {
			this.add(coords);
		} else {
			// pridani bodu - zobrazeni interakce
			if (this._interactivePoint.visible || !this._items.length) {
				this.add(coords);

				// skryjeme - pri zobrazeni dojde k rebindu
				this._interactivePoint.hide();

				// update kese, kde jsou vsechny geometrie
				this._interactivePoint.cleanCache();

				// zobrazime a pokud nebyl aktivovany, aktivujeme
				if (this._items.length == 1) {
					this._interactivePoint.show(coords.x, coords.y, clientX, clientY);
				}
			} else {
				this._interactivePoint.show(coords.x, coords.y, clientX, clientY);
			}
		}

		const scrollNode = Mapy.getComponent("layout").getScrollNode();
		const bodyNode = Mapy.getComponent("layout").getBody();
		scrollNode.scrollTop = bodyNode.clientHeight;
	}

	/**
	 * Klik do mapy.
	 *
	 * @param  {Event} e
	 */
	async mapClick (e, smapItem, marker) {
		let coords = marker
			? marker.getCoords()
			: await Scene.coordsFromEventAsync(e);

		this._mapClick(coords, e);
	}

	/**
	 * Podbarveni radku tabulky a geometrie.
	 */
	sectionHighlight(isEnter, index, withGeom) {
		if (!this._allowHover || this._dragging) {
			return;
		}

		const wasmBulk = new WasmBulkMode();

		this._dom.tableHeader.classList[isEnter && index > 0 ? "add" : "remove"]("hover");
		this._dom.tableBody.classList[isEnter || this._isSortabling ? "add" : "remove"]("global-hover");

		// pre line - predchozi lajne podbarvime spodni caru k bodu
		let preLine = index > 0 ? this._dom.tableBody.querySelector("tr:nth-child(" + index + ")") : null;
		let line = this._dom.tableBody.querySelector("tr:nth-child(" + (index + 1) + ")");

		if (preLine && !this._isSortabling) {
			preLine.classList[isEnter ? "add" : "remove"]("pre-active");
		}

		if (line && !this._isSortabling) {
			line.classList[isEnter ? "add" : "remove"]("active");
		}

		// podbarveni geometrii
		if (withGeom) {
			let find = null;

			this._items.forEach((i, ind) => {
				// pri isEnter - vsechny jsou sede, jenom nektere cervene
				if (isEnter) {
					i.setHover(false, wasmBulk);

					if (ind == index) {
						find = i;
					}
				} else {
					i.setHover(true, wasmBulk);
				}
			});

			// nalezl jsem pri isEnter hledanou geometrii - podbarvime
			if (find) {
				if (index === 0) {
					find.setPointHover(true, wasmBulk);
				}
				find.setLineHover(true, wasmBulk);

				if (find.next) {
					find.next.setPointHover(true, wasmBulk);
				}
			}
		}

		wasmBulk.run();
	}

	/**
	 * vrati itemy pro context menu
	 * @param  {Object} e udalost
	 * @return {Array}   itemy pro context menu
	 */
	getContextMenuItems (e) {
		let items = [];
		let target = null;

		for (let i = 0; i < this._items.length; i++) {
			if (target = this._items[i].isTarget(e)) {
				break;
			}
		}

		if (target) {
			this._contextMenuItems[0].setData(target.point, target.index);
			items.push(this._contextMenuItems[0]);
		}
		else {
			this._contextMenuItems[1][this._interactivePoint.visible ? "enable" : "disable"]();
			this._contextMenuItems[2][this._items.length >= 1 ? "enable" : "disable"]();
			items.push(this._contextMenuItems[1]);
			items.push(this._contextMenuItems[2]);
		}

		return items;
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_build () {
		// hlavicka
		let header = node("div", { className: "header" });
		let title = node("h1", { className: "title", textContent: _("distanceMeter.title") });

		const btns = node("div", { className: "header-buttons" });
		const exitBtn = node("button", { className: "edit-props-btn" });

		exitBtn.addEventListener("click", this);
		exitBtn.appendChild(createSDSIcon({ className: "edit-props-btn-icon-exit", symbol: MYMAPS_CLOSE }));

		this._ctxtMenuBtn = createContextMenuBtn({
			place: "distancemeter-detail",
			clickCb: name => {
				switch (name) {
					case "edit":
						this._mymapsDialog("edit");
						break;

					case "move-to-folder":
						new MyMapsMoveItems({
							item: this._likeData,
							ids: [this._likeData.id],
							moveFolders: [{
								id: this._likeData.parent_id,
								title: this._likeData.parent_name
							}],
							onSave: (folderId, folderTitle) => {
								this._likeData.parent_id = folderId;
								this._likeData.parent_name = folderTitle;

								this._mymapsBox.rebuild({
									parent_id: folderId,
									parent_name: folderTitle,
								});
							},
						}).open();
						break;

					case "delete":
						new MyMapsRemove({
							data: this._likeData,
							onRemove: () => {
								this._clearLikeData();
								Mapy.getComponent("history").save(true);
							},
						}).open();
						break;

					default:
				}
			},
		});
		this._ctxtMenuBtn.hide();

		header.appendChild(title);
		btns.append(this._ctxtMenuBtn.container, exitBtn);
		header.append(btns);

		// akce
		var contentActions = node("div", { className: "actions" });
		var div = node("div");
		div.appendChild(this._actions.save.container);
		div.appendChild(this._actions.share.container);
		div.appendChild(this._actions.download.container);
		contentActions.appendChild(div);
		contentActions.appendChild(this._actions.clear.container);

		// tabulka - obal
		// table head const, body remove
		let tableHeader = node("table", { className: "table-header" });
		let tableHead = node("thead");
		tableHeader.appendChild(tableHead);
		this._buildHeader(tableHead);

		let tableData = node("table", { className: "table-data" });
		let tableBody = node("tbody");
		tableData.appendChild(tableBody);

		// info
		let info = node("p", { className: "info" });
		let infoContinue = node("p", { className: "info-continue", textContent: _("distanceMeter.continue") });

		// vzdalenost a plocha
		let distanceAreaCont = node("ul", { className: "distance-area-cont" });
		let distance = node("li", { className: "distance" });
		distance.appendChild(node("small", { className: "title", textContent: _("distanceMeter.summary") }));
		let distanceValue = node("strong", { className: "value" });
		let distanceUnit = node("small", { className: "unit" });
		distance.appendChild(distanceValue);
		distance.appendChild(distanceUnit);
		distanceAreaCont.appendChild(distance);
		let area = node("li", { className: "area" });
		area.appendChild(node("small", { className: "title", textContent: _("distanceMeter.area") }));
		let areaValue = node("strong", { className: "value" });
		let areaUnit = node("small", { className: "unit" });
		area.appendChild(areaValue);
		area.appendChild(areaUnit);
		distanceAreaCont.appendChild(area);

		// vyskovy profil - obal
		let lineChartCont = node("div", { className: "line-chart-cont" });

		// hlavicka - sekce
		let headerSection = node("div", { className: "header-section" });
		let headerSectionBg = node("div", { className: "header-section-bg" });
		let likeText = node("div", { className: "like-text" });
		headerSectionBg.appendChild(header);
		headerSectionBg.appendChild(contentActions);
		let m3dReadOnly = node("p", { className: "m3d-readonly", textContent: _("userMarks.readOnly") });
		headerSectionBg.appendChild(m3dReadOnly);
		headerSection.appendChild(headerSectionBg);
		headerSection.appendChild(likeText);
		headerSection.appendChild(tableHeader);
		headerSection.appendChild(node("div", { className: "separator" }));

		// scroll sekce
		let scrollSection = node("div", { className: "scroll-section" });
		scrollSection.appendChild(tableData);
		scrollSection.appendChild(node("div", { className: "separator" }));
		scrollSection.appendChild(info);
		scrollSection.appendChild(infoContinue);
		scrollSection.appendChild(distanceAreaCont);
		scrollSection.appendChild(lineChartCont);

		this._dom.container.appendChild(headerSection);
		this._dom.container.appendChild(scrollSection);

		this._dom.m3dReadOnly = m3dReadOnly;
		this._dom.title = title;
		this._dom.exitBtn = exitBtn;
		this._dom.tableHeader = tableHeader;
		this._dom.tableBody = tableBody;
		this._dom.tableData = tableData;
		this._dom.info = info;
		this._dom.infoContinue = infoContinue;
		this._dom.distanceAreaCont = distanceAreaCont;
		this._dom.distanceValue = distanceValue;
		this._dom.distanceUnit = distanceUnit;
		this._dom.areaValue = areaValue;
		this._dom.areaUnit = areaUnit;
		this._dom.lineChartCont = lineChartCont;
		this._dom.headerSection = headerSection;
		this._dom.scrollSection = scrollSection;
		this._dom.headerSectionBg = headerSectionBg;
		this._dom.likeText = likeText;

		this._createListStyles();
		this._sortableItems = new Mapy.Sortable(this._dom.tableBody, { handle: "tr", item: "tr", placeholderNodeType: "tr" });
		this._dom.tableBody.addEventListener("sortable-end", this);
		this._dom.tableBody.addEventListener("sortable-start", this);
		this._dom.tableBody.addEventListener("sortable-move", this);
	}

	/**
	 * Vytvoreni hlavicky tabulky.
	 *
	 * @param  {Element} tableHead thead
	 */
	_buildHeader (tableHead) {
		let line = node("tr");

		[
			_("distanceMeter.header1"),
			_("distanceMeter.header2"),
			_("distanceMeter.header3"),
			_("distanceMeter.header4")
		].forEach((i, ind) => {
			let th = node("th", { textContent: i });

			if (ind === 0) {
				this._createRowMark(th);
			}

			line.appendChild(th);
		});

		tableHead.appendChild(line);
	}

	/**
	 * Vytvoreni taublky.
	 */
	_buildTable (opts) {
		// smazeme
		if (!opts.add || this._items.length <= 2) {
			this._dom.tableBody.innerHTML = "";
		}

		let summary = 0;
		let coords = [];
		let len = this._items.length;
		this._createListStyles(len);


		this._items.forEach((item, ind) => {
			let rowData = null;

			coords.push(item.getCoords());

			if (ind == 0 && len == 1) {
				rowData = {
					ind: 0,
					distance: "",
					summary: "",
					azimuth: ""
				};
			} else if (ind > 0) {
				let prevCoords = coords[ind - 1];
				let distance = this._readOnly ? this._readOnlyDistance : coords[ind].distance(prevCoords);
				let azimuth = this._readOnly ? "" : Math.round(prevCoords.azimuth(coords[ind])) + "°";

				summary += distance;

				rowData = {
					ind,
					distance: Mapy.Util.formatDistancemeterDistance(distance).string,
					summary: Mapy.Util.formatDistancemeterDistance(summary).string,
					azimuth
				};
			}

			if ((rowData && !opts.add) || (rowData && opts.add && ind == len - 1)) {
				this._dom.tableBody.appendChild(this._createRow(rowData));
			}
		});
	}

	/**
	 * Vytvoreni radku tabulky.
	 *
	 * @param  {Object} data Data 1 radku
	 * @param  {Number} data.ind Index 0..n
	 * @param  {Number} data.distance Vzdalenost
	 * @param  {Number} data.summary Celkova vzdalenost
	 * @param  {Number} data.azimuth Azimut
	 * @return {Element} tr
	 */
	_createRow (data) {
		let newLine = node("tr");
		newLine.setAttribute("data-index", data.ind - 1);
		let partTd = node("td", { textContent: (data.ind < 1 ? 1 : data.ind) + "." });
		let distanceTd = node("td", { textContent: data.distance });
		let summaryTd = node("td", { textContent: data.summary });
		let azimuthTd = node("td", { textContent: data.azimuth, className: "azimuth" });

		if (!this._readOnly) {
			let removeLineBtn = node("button", { className: "remove-line" });
			removeLineBtn.appendChild(icon("delete"));
			removeLineBtn.addEventListener("click", e => {
				this.remove(data.ind);
			});
			azimuthTd.appendChild(removeLineBtn);
		}

		this._createRowMark(partTd);

		newLine.addEventListener("pointerenter", e => {
			if (!this._m3dData.active) {
				let enterIndex = e.target.getAttribute("data-index");
				if (enterIndex) {
					this.sectionHighlight(true, parseInt(enterIndex), true);
				}
			}
		});
		newLine.addEventListener("pointerleave", e => {
			if (!this._m3dData.active) {
				let leaveIndex = e.target.getAttribute("data-index");
				if (leaveIndex) {
					this.sectionHighlight(false, parseInt(leaveIndex), true);
				}
			}
		});
		newLine.appendChild(partTd);
		newLine.appendChild(distanceTd);
		newLine.appendChild(summaryTd);
		newLine.appendChild(azimuthTd);

		return newLine;
	}

	/**
	 * Vytvoreni fake cary do tabulky (uplne vlevo)
	 *
	 * @param  {Element} el Kam je pripnout?
	 */
	_createRowMark (el) {
		let topLine = node("span", { className: "top-line" });
		let bottomLine = node("span", { className: "bottom-line" });
		let circle = node("span", { className: "circle" });

		el.appendChild(topLine);
		el.appendChild(bottomLine);
		el.appendChild(circle);
	}

	/**
	 * Pridani souradnic - rozdil readonly.
	 *
	 * @param {Array} coords
	 */
	_addCoords (coords) {
		let len = coords.length;

		if (this._readOnly) {
			if (len >= 2) {
				this._readOnlyCoords = coords;
				this._readOnlyDistance = 0;

				// celkova vzdalenost
				coords.forEach((i, ind) => this._readOnlyDistance += ind > 0 ? coords[ind].distance(coords[ind - 1]) : 0);

				let startCoords = coords[0];
				let endCoords = coords[len - 1];
				let firstItem = new Item(this, Scene, startCoords, endCoords);
				firstItem.linePoints = coords;

				this._items.push(firstItem);
				this._items.push(new Item(this, Scene, endCoords, null));
			}
		} else {
			const wasmBulk = new WasmBulkMode();

			coords.forEach((coord, ind) => {
				this._items.push(new Item(this, Scene, coord, ind < len ? coords[ind + 1] : null, wasmBulk));
			});
			wasmBulk.run();
		}

		this.redraw();
	}

	/**
	 * Ziskani dat pro export.
	 *
	 * @return {Object}
	 */
	_getExportData () {
		let out = {};
		let geometry;

		out.criterion = "hand";

		if (this._readOnly) {
			geometry = this._items.length > 1 ? Scene.coordsToString(this._items[0].getLinePoints()) : "";
		}
		else {
			geometry = this._getGeometryCoordsData();
		}

		out.geometry = geometry;

		return out;
	}

	/**
	 * Ziskani bodu pro vyskovy profil.
	 *
	 * @param {Boolean} [coordsOutput] Vratit pole souradnic, ne string
	 * @return {Array[SceneCoords]}
	 */
	_getAltitudeCoords(coordsOutput) {
		let coords = [];
		let lastInd = this._items.length - 1;

		this._items.forEach((item, ind) => {
			coords.push(item.getCoords());

			if (ind >= 0 && ind <= lastInd) {
				let itemLinePoints = item.getLinePoints();

				if (itemLinePoints.length > 2) {
					// odstranime prvni a posledni
					let points = itemLinePoints.slice(1, itemLinePoints.length - 1);

					points.forEach(point => {
						coords.push(point);
					});
				}
			}
		});

		return (coordsOutput ? coords : Scene.coordsToString(coords));
	}

	/**
	 * Ziskani vyskoveho profilu.
	 */
	_getAltitude () {
		if (!this._items.length) {
			return;
		}

		this._abortAltitudeRequest();

		let coords = this._getAltitudeCoords();

		this._altitudeFrpc = altitudeProfile(coords);
		this._altitudeFrpc.promise.then(data => {
			this._altitudeFrpc = null;
			this._buildLineChart(data);
		}, e => {
			this._altitudeFrpc = null;
		});

		return this._altitudeFrpc.promise;
	}

	/**
	 * Zrusime request pro vyskovy profil.
	 */
	_abortAltitudeRequest () {
		if (this._altitudeFrpc) {
			this._altitudeFrpc.request.abort();
			this._altitudeFrpc = null;
		}
	}

	/**
	 * Vytvoreni vyskoveho profilu.
	 */
	_buildLineChart (data) {
		if (this._interactive) {
			this._interactive.destroy();
			this._interactive = null;
		}

		let distance = this.distance;
		let options = {};

		if (this._prevOffsetWidth) {
			options.width = this._prevOffsetWidth;
		}

		this._altitudeData = data;

		if (!this._lineChart) {
			this._lineChart = new LineChart(data.altitude, distance, options);
			this._dom.lineChartCont.appendChild(this._lineChart.getContainer());
		} else {
			this._lineChart.setData(data.altitude, distance, options);
		}

		let allGeometries = [];

		this._items.forEach((item, ind) => {
			let itemGeom = item.line.geom;

			if (itemGeom) {
				allGeometries.push(itemGeom);
			}
		});

		if (!CONFIG.inFrame) {
			this._interactive = new InteractiveLineChart(this._lineChart, allGeometries, { config: CONFIG });
		}
		this._resize();
		this._createLayers3d();
	}

	/**
	 * Event pri zmene okna - uprava rozmeru vyskoveho profilu.
	 */
	_resize(dimensions = {
		width: window.innerWidth,
		height: window.innerHeight
	}) {
		// pro mobily zakazeme d&d
		this._sortableItems.enabled = this._m3dData.active ? false : !Mapy.Util.isMobile();

		if (this._lineChart) {
			let width = Mapy.getComponent("layout").getScrollNode().offsetWidth;
			width = (width > 0 ? width : 400) - LINE_CHART_PADDING;

			if (this._prevOffsetWidth != width) {
				this._lineChart.setData(undefined, undefined, { width });
				this._prevOffsetWidth = width;
			}
		}

		// zmena sticky na absolute a zpet podle vysky hlavicky a layoutu
		this._dom.headerSection.classList[dimensions.height - this._headerHeight < 300 || !this._noteSafeHeight ? "add" : "remove"]("high");
	}

	/**
	 * Vytvoreni kontext menu.
	 */
	_makeContextMenu () {
		this._contextMenuItems.push(getContextMenu(this));
		this._contextMenuItems.push(Mapy.Util.createContextMenuItem(_("distanceMeter.cancel"), false, (e, menu) => {
			this._interactivePoint.hide(true);
			e.stopPropagation();
			menu.close();
		}));
		this._contextMenuItems.push(Mapy.Util.createContextMenuItem(_("distanceMeter.clear"), false, (e, menu) => {
			Mapy.getComponent("logger").log("measure", { end_measure: "clear", count: this._items.length - 1 });
			this.removeAll();
			e.stopPropagation();
			menu.close();
		}));
	}

	/**
	 * Nastavime kurzor.
	 *
	 * @param {String} cursor Nazev/cesta k obrazku
	 */
	_setCursor (cursor) {
		if (this._cursor) {
			Mapy.Cursor.update(this._cursor, { cursor, callback: this });
		}
	}

	/**
	 * Zobrazeni infa ohledne pokracovani v mereni.
	 *
	 * @param  {Boolean} state
	 */
	_showContinue (state) {
		if (!this._items.length || this._readOnly) {
			this._dom.infoContinue.classList.add("hide");
		} else {
			this._dom.infoContinue.classList[state ? "add" : "remove"]("hide");
		}
	}

	/**
	 * Update hlavicky - scroll nebo manual.
	 */
	_updateHeader() {
		let scrollTop = Mapy.getComponent("layout").getScrollNode().scrollTop;

		this._dom.headerSection.classList[scrollTop > DISTANCEMETER_ACTION_TRESHOLD ? "add" : "remove"]("scrolled");
	}

	/**
	 * Prekresleni mapy - rebind eventu.
	 */
	_mapRedraw () {
		this._items.forEach(item => item.bindTo());
	}

	/**
	 * mazani dat z moje mapy
	 */
	_clearLikeData () {
		if (this._likeData) {
			this._dom.likeText.innerHTML = "";
			this._dom.likeText.classList.remove("foreign");
			this._dom.likeText.classList.remove("empty");
			this._userNote?.destroy();
			this._mymapsBox?.destroy();
			this._userNote = null;
			this._mymapsBox = null;
			this._change(false);
			this._likeData = null;
			this._ctxtMenuBtn.hide();
			this._actions.save.updateProps = {
				title: _("action.save.title"),
			};
			Mapy.getComponent("dimcurator").setState();

			this._dom.title.textContent = _("distanceMeter.title");
			this._dom.container.classList.remove("like");
		}
	}

	/**
	 * data pro ukladani do moje mapy
	 * @return {object} data
	 */
	_buildActionData () {
		let distance = Mapy.Util.formatDistancemeterDistance(this.distance).string;
		let saveData = {
			points: this._getExportData().geometry,
			title: _("distanceMeter.module.title", {
				distance
			}),
			subtitle: _("distanceMeter.module.subtitle", {
				count: this._items.length-1,
				section: this._items.length-1,
				distance
			}),
		};

		if (this._likeData) {
			if ("usertitle" in this._likeData) {
				saveData.usertitle = this._likeData.usertitle;
			}

			if (this._likeData.description) {
				saveData.description = this._likeData.description;
			}
		}

		if (this._readOnly) {
			saveData.readonly = 1;
		}

		return saveData;
	}

	_getGeometryCoordsData () {
		let coords = [];
		this._items.forEach(item => {
			coords.push(item.getCoords());
		});

		return Scene.coordsToString(coords);
	}

	_change(change) {
		if (this._likeData) {
			this._likeChange = change;
			if (!("owner_name" in this._likeData)) {
				this._actions.save.props = Object.assign(this._actions.save.props, { change: change, title: change ? _("action.save.changeTitle") : _("action.save.title") });
			}

			if (change && this._likeData.foreign) {
				this._clearLikeData();
			}

			Mapy.getComponent("dimcurator").setState(!change ? { dim: this._likeData.id } : undefined);
		}
	}

	/**
	 * Nastaví výšku kontejneru pro D&D
	 */
	_setHeights () {
		let count = this._dom.tableBody.querySelectorAll("tr").length;
		let height = count * ITEM_HEIGHT;

		this._dom.tableData.style.height = height + "px";
		this._dom.tableBody.style.height = height + "px";
	}

	/**
	 * Vytvoří (upraví existující) stylopis potřebný pro D&D a vloží jej do stránky
	 * @param {Number} count počet prvků k vytvoření
	 */
	_createListStyles (count) {
		if (count > this._sortableIndex) {
			if (!this._sortableSheet) {
				this._sortableSheet = node("style", { type: "text/css", id: STYLE_ID });
				document.querySelector("head").appendChild(this._sortableSheet);
			}

			for (let i = this._sortableIndex; i < count; i++) {
				this._sortableSheet.innerHTML += `tbody.sortable > tr:nth-child(${i + 1}) { transform: translate3d(0, ${i * 100}%, 0); } \n`;
			}
			this._sortableIndex = count;
		}
	}

	/**
	 * Smaže chybovou hlášku
	 */
	_deleteError () {
		this.removeAll();
		this._dom.info.classList.remove("error");
		this._hasError = false;
	}

	_createLayers3d() {
		if (this._layers.distanceMeter || this._layers.free || Scene.isMapActive() || !this._altitudeData) return;

		let markerCoords = this._items.map(i => i.getCoords());

		// cary vykreslime pres volnou vrstvu
		this._layers.distanceMeter = Scene.createLayerDistanceMeter(markerCoords.map(i => i.toWGS84()), [], {
			startTexture: M3D_TEXTURE.mapping.circleWhite,
			texture: M3D_TEXTURE.mapping.circleRed
		});

		// roztahneme na 1000 souradnic
		let distances = Mapy.Util.IP.countDistances(markerCoords);
		let distance = distances.length ? distances[distances.length - 1] : 0;
		let lineCoords;

		// nad 50 km -> trasu a ma malo bodu; nebo je rozdil max-min vic jak 1000 metru
		if ((distance > M3D_VALUES.MIN_KM * 1000 || Math.abs(this._altitudeData.altitude.max - this._altitudeData.altitude.min) > M3D_VALUES.MAX_MIN_DISTANCE) && this._altitudeData.altitude.data.length < M3D_VALUES.POINTS_LENGTH) {
			lineCoords = [Mapy.Util.IP.resizePath(this._altitudeData.altitude.data.map(i => Scene.coordsFromWGS84(i.lon, i.lat)), {
				count: M3D_VALUES.POINTS_LENGTH,
				returnWGS84: true
			})];
		}
		else {
			lineCoords = [this._altitudeData.altitude.data.map(i => [i.lon, i.lat])];
		}

		this._layers.free = Scene.createLayerFree("route", lineCoords, {
			lineWidth: 10,
			outlineOffset: [-0.19, 0, 0],
			outlineWidth: 0
		});

		Scene.addLayer(this._layers.distanceMeter).enable();
		Scene.addLayer(this._layers.free).enable();
	}

	_removeLayers3d() {
		if (this._layers.distanceMeter) {
			Scene.removeLayer(this._layers.distanceMeter).disable();
			this._layers.distanceMeter.destroy();
			this._layers.distanceMeter = null;
		}

		if (this._layers.free) {
			Scene.removeLayer(this._layers.free).disable();
			this._layers.free.destroy();
			this._layers.free = null;
		}
	}

	_enableM3d(force) {
		if (!force && (Scene.isMapActive() || this._m3dData.active)) return;

		this._m3dData.active = true;
		this._m3dData.hover = this._allowHover;
		this._m3dData.dad = this._sortableItems.enabled;
		this._dom.container.classList.add("m3d-active");

		this._allowHover = false;
		this._sortableItems.enabled = false;
	}

	_disableM3d() {
		if (this._m3dData.active) {
			this._m3dData.active = false;
			this._allowHover = this._m3dData.hover;
			this._sortableItems.enabled = this._m3dData.dad;
			this._dom.container.classList.remove("m3d-active");
		}
	}

	_showLabelInFrame(showLabel) {
		let coords = Scene.coordsFromWGS84(this._likeData.mark.lon, this._likeData.mark.lat);
		let marker = Scene.createMarkerMapyWindy(coords, null, { type: Scene.VISUAL.MARKER_WINDY.LITTLE });
		marker.setLabel(showLabel === 1 ? this._likeData.usertitle : this._likeData.usertitle || this._likeData.title);
		marker.setStyle("visibility", "hidden");
		this._layers.label.addMarker(marker);
		Scene.addLayer(this._layers.label).enable();
	}

	_exit() {
		if (this._hasError) {
			this._deleteError();
		}
		this.removeAll();
		this._resize();
		Mapy.getComponent("distanceMeter").deactivate();
		Mapy.getComponent("logger").log("measure", { end_measure: "close" });
		Mapy.getComponent("history").save();
	}

	_onNoteOpen(container) {
		this._noteSafeHeight = isNoteHeightSafe(container);
		this._resize();
	}

	_mymapsDialog(mode: TMymapsMode) {
		const saveData = this._buildActionData();
		const isReplace = mode === "replace" && "parent_name" in this._likeData;
		const folderData = getFolderData();

		if (mode === "create") {
			Mapy.getComponent("logger").log("click", {
				text: "uložit_hvězda",
				type: "measure"
			});
		}

		new MyMapsMapyBoxItem({
			isPremiumUser: isPremiumNoteUser(),
			noteVersion: getNoteVersion(),
			...mode !== "edit"
				? {
					createData: getCreateLikeData(saveData, "measure"),
				}
				: {},
			...folderData
				? {
					folder: folderData,
				}
				: {},
			...isReplace || mode === "edit"
				? {
					mode: mode === "edit" ? "edit" : this._likeChange ? "replace" : "save-as-new",
					likeData: this._likeData,
					folder: {
						id: this._likeData.parent_id,
						title: this._likeData.parent_name,
					},
				}
				: {
					mode: "create",
				},
			onSave: ({ likeData: newLikeData }) => {
				this._mymapsDialogSave(mode, newLikeData);
			},
		}).open();
	}

	_mymapsDialogSave(mode: TMymapsMode, likeData: IMapyBoxItem) {
		this._change(false);

		// ulozime
		if (this._likeData) {
			Object.assign(this._likeData, likeData);
		} else {
			this._likeData = likeData;
		}

		if (mode === "create") {
			mapyboxAnalyticsSave({
				type: "measure",
				note: !!likeData.description,
			});
		}

		if (mode !== "edit") {
			const isReplace = mode === "replace" && "parent_name" in this._likeData;

			Mapy.getComponent("logger").log("click", {
				type: "set",
				origin: "measure",
			});

			if (isReplace) {
				this._likeData.data.points = this._getGeometryCoordsData();
				Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
				Mapy.getComponent("history").save();
			} else {
				let first = this._items[0].getCoords().toWGS84(0);
				let last = this._items[this._items.length - 1].getCoords().toWGS84(0);

				Mapy.getComponent("logger").log("measure", {
					end_measure: "save",
					count: this._items.length - 1,
					fromLat: first[1],
					fromLon: first[0],
					toLat: last[1],
					toLon: last[0],
					length: this.distance
				});
			}

			Mapy.getComponent("dimcurator").setState({ dim: likeData.id }).loadData().then(() => {
				Mapy.getComponent("logger").log("measure", { end_points: "save", count: this._items.length - 1 });
				Mapy.getComponent("history").save();
			}, () => {});
		} else {
			this._dom.title.textContent = this._likeData.usertitle || this._likeData.title;
		}
	}
}
